import { services } from '@/mocks/services';

export default function ServicesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            核心服务
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            一站式体育运动解决方案
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            覆盖体育培训、赛事组织、运动装备和场馆管理四大领域，满足您的全方位运动需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/90 backdrop-blur-sm">
                    <i className={`${service.icon} text-background-50 text-base`}></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{service.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}